import React from 'react'
import PageIntro from '../../../../../presentation/pages/common/amplify/intro/intro'

function MakeIntro() {
  const handleUserTypeChange = (userType: string) => {
    localStorage.setItem('userType', userType)
  }

  return <PageIntro handleButtonClick={handleUserTypeChange} />
}

export default MakeIntro
